import { useState } from "react";
import { getClass } from "../../../Helper";
import moment from "moment";
import { getDayOfWeek, teacherStatus, teacherResponse } from "../../../Helper";
import { notify } from "react-notify-toast";
import { API } from "../../../API";

const useBookingModal = (props) => {
  const [classOptions, setClassOptions] = useState([]);
  const [selectClass, setSelectClass] = useState([]);
  const [levelOptions, setLevelOptions] = useState([]);
  const [selectCampus, setSelectCampus] = useState();
  const [checkCampus, setCheckCampus] = useState(false);
  const [classId, setClassId] = useState();
  const [level, setLevel] = useState();
  const [toDate, setToDate] = useState(props.bookingStates.selected_date);
  const [fromDate, setFromDate] = useState(props.bookingStates.selected_date);
  const [radioDeliveryMode, setRadioDeliveryMode] = useState("On campus");
  const [radioTeachingMode, setRadioTeachingMode] = useState("Daily");
  const [checkNonTeaching, setCheckNonTeaching] = useState();
  const [dailyNonTeachingTime, setDailyNonTeachingTime] = useState();
  const [weeklyNonTeachingTime, setWeeklyNonTeachingTime] = useState();
  const [monthlyNonTeachingTime, setMonthlyNonTeachingTime] = useState();
  const [radioNonTeaching, setRadioNonTeaching] = useState("Before class");
  const [radioOnlineMode, setRadioOnlineMode] = useState("Deliver on-campus");
  const classList = getClass();

  const changeNTTcheck = (e) => {
    if (e.target.checked) {
      setCheckNonTeaching(true);
      setDailyNonTeachingTime(10);
      setWeeklyNonTeachingTime(30);
      setMonthlyNonTeachingTime(60);
    } else {
      setCheckNonTeaching(false);
      setDailyNonTeachingTime(0);
      setWeeklyNonTeachingTime(0);
      setMonthlyNonTeachingTime(0);
      setRadioNonTeaching("");
    }
  };

  const changeDailyNonTeachingTime = (e) => {
    if (radioTeachingMode === "Daily") {
      setDailyNonTeachingTime(e.target.value);
    } else {
      setWeeklyNonTeachingTime(e.target.value);
    }
  };

  const getClassNameList = () => {
    const refList = [];
    for (let i = 0; i < props.classes.length; i++) {
      if (props.classes[i]) {
        const refName = {
          name:
            "reference_name" in props.classes[i]
              ? props.classes[i].reference_name
              : "default_ref",
          value: props.classes[i]._id,
        };
        refList.push(refName);
      }
    }
    return refList;
  };

  const getClassName = (key) => {
    const cls = classList.find((cl) => cl.key === key) || {};
    return cls.whole_name;
  };

  const changeLevel = (e) => {
    const level = e.target.value;
    const select_class =
      classOptions.find((cls) => cls.level.includes(level)) || {};
    setSelectClass(select_class);
    setClassId(select_class._id);
    setLevel(level);
  };

  const changeFromDate = (date) => {
    if (toDate == null || toDate < date) {
      setToDate(date);
    }
    setFromDate(date);
  };

  const changeToDate = (date) => {
    if (fromDate == null) {
      const selected_date = props.selected_date;
      setFromDate(selected_date);
    }
    if (fromDate > date) {
      setFromDate(date);
    }
    setToDate(date);
  };

  const changeSavedClass = (e) => {
    const classId = e.target.value;
    const selected_class = props.classes.find((cls) => cls._id === classId);
    if (selected_class) {
      let levelList = [];
      selected_class.level.forEach((lvl) => {
        if (!levelList.includes(lvl)) {
          levelList.push(lvl);
        }
      });
      setClassOptions([selected_class]);
      setSelectClass(selected_class);
      setLevelOptions(levelList);
      setSelectCampus(selected_class.campus_id);
      setCheckCampus(true);
    } else {
      setLevelOptions([]);
      setSelectCampus("");
      setCheckCampus(false);
    }
  };

  const getDateRangeDescription = () => {
    let result;

    const from_date = fromDate
      ? new Date(fromDate)
      : new Date(props.bookingStates.selected_date);
    const to_date = toDate
      ? new Date(toDate)
      : new Date(props.bookingStates.selected_date);

    const fromDateStr = moment(from_date).format("DD-MM-YYYY");
    const toDateStr = moment(to_date).format("DD-MM-YYYY");

    if (fromDateStr === toDateStr) {
      result = fromDateStr;
    } else {
      result = fromDateStr + " to " + toDateStr;
    }

    return result;
  };

  const getCampusName = () => {
    const campus = props.campuses.find((cp) => cp._id === selectCampus);
    return campus ? campus.address_line1 + ", " + campus.suburb : "";
  };

  const formateDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  const checkIfSingleBookingMatchesWithTimetable = () => {
    let result = false;

    const from_date = fromDate ? fromDate : props?.bookingStates?.selected_date;
    const end_date = toDate ? toDate : props?.bookingStates?.selected_date;

    const selected_class = props.classes.find(
      (cls) => cls._id === selectClass._id
    );

    if (selected_class) {
      var splited = selected_class.days_of_delivery.split(",");
      for (let i = 0; i < 7; i++) {
        let date = new Date(from_date);
        let index = date.getDate() + i;
        date = date.setDate(index);
        date = new Date(date);
        let endDate = new Date(end_date);
        if (date > endDate) {
          break;
        }
        const dayOfWeek = getDayOfWeek(date.toString());
        if (splited.includes(dayOfWeek)) {
          result = true;
          break;
        }
      }
    }
    return result;
  };

  const buildBookingAllocations = () => {
    const from_date = fromDate ? fromDate : props?.bookingStates.selected_date;
    const to_date = toDate ? toDate : props?.bookingStates.selected_date;

    const dates = [];
    const selected_class = props.classes.find(
      (cls) => cls._id === selectClass._id
    );
    if (selected_class) {
      var splited = selected_class.days_of_delivery.split(",");
      for (var d = from_date; d <= to_date; d.setDate(d.getDate() + 1)) {
        const dayOfWeek = getDayOfWeek(d);
        if (splited.includes(dayOfWeek)) {
          const allocation = {
            date: formateDate(d),
            teacher_id: null,
            teacher_response: "unresponded",
            teacher_status: "unassigned",
            payment_status: "",
          };
          dates.push(allocation);
        }
      }
    }

    return dates;
  };

  const saveDate = async () => {
    const cls = selectClass;

    const today = new Date();
    const date =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();
    const time =
      today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    const dateTime = date + " " + time;

    let fd = null;
    let td = null;
    if (!fromDate) {
      fd = formateDate(props?.bookingStates?.selected_date);
    } else {
      fd = formateDate(fromDate);
    }

    if (!toDate) {
      td = formateDate(props?.bookingStates?.selected_date);
    } else {
      td = formateDate(toDate);
    }

    let dates = [];
    let continueCreateBooking = true;
    const multiple_date = !(fd === td);
    if (multiple_date && checkIfSingleBookingMatchesWithTimetable()) {
      dates = buildBookingAllocations();
    } else {
      if (!checkIfSingleBookingMatchesWithTimetable()) {
        continueCreateBooking = false;
        notify.show(
          "Your selected booking day does not match with your timetable. Please navigate to Timetable to update your schedule for this class."
        );
        props.handleCloseBooking();
      }
    }

    if (continueCreateBooking) {
      const new_booking = {
        booking_date: fd,
        end_booking_date: td,
        multiple_date: multiple_date,
        dates: dates,
        created_dateTime: dateTime,
        comment: "",
        class_id: classId,
        level: level,
        start_time: cls.start_time,
        end_time: cls.end_time,
        arrival_time: cls.arrival_time,
        paid_teaching_hours: cls.paid_teaching_hours,
        non_teach_calculation: radioTeachingMode.toLowerCase(),
        paid_nonteaching_mins: checkNonTeaching
          ? radioTeachingMode === "Daily"
            ? dailyNonTeachingTime
            : radioTeachingMode === "Weekly"
            ? weeklyNonTeachingTime
            : radioTeachingMode === "Monthly"
            ? monthlyNonTeachingTime
            : 0
          : 0,
        campus_id: cls.campus_id,
        teacher_status: teacherStatus.not_assigned,
        teacher_response: teacherResponse.not_responded,
        Gcal_events: null,
        teacher_id: null,
        introduction_module_link: null,
        payment_status: "",
        online: radioDeliveryMode === "Online",
        deliver_from_home: radioDeliveryMode === "Deliver from home",
        booking_maker: props.user.customer_id
          ? props.user.customer_id
          : props.user.personnel_id,
        splits: [],
        days_of_delivery:
          cls.days_of_delivery.charAt(0) === ","
            ? cls.days_of_delivery.substring(1, cls.days_of_delivery.length)
            : cls.days_of_delivery,
        is_childcare_centre: props.user.is_childcare_centre || false,
      };

      new_booking.preferred_teacher = props?.teacher._id;
      await API.addMultipleDayBooking(
        new_booking,
        props.user.customer_id ? props.user.email : props.user.personnel_email
      );
      notify.show("Booking made successfully.");
      props.handleCloseBooking();
    } else {
      props.handleCloseBooking();
    }
  };

  return {
    ...props,
    classNameList: getClassNameList(),
    levelOptions,
    selectCampus,
    radioDeliveryMode,
    setRadioDeliveryMode,
    fromDate,
    toDate,
    selectClass,
    checkNonTeaching,
    level,
    dailyNonTeachingTime,
    weeklyNonTeachingTime,
    radioTeachingMode,
    radioOnlineMode,
    radioNonTeaching,
    setRadioTeachingMode,
    setRadioNonTeaching,
    setRadioOnlineMode,
    changeSavedClass,
    changeLevel,
    getClassName,
    changeFromDate,
    changeToDate,
    getCampusName,
    getDateRangeDescription,
    changeNTTcheck,
    changeDailyNonTeachingTime,
    saveDate,
  };
};

export default useBookingModal;
